import { useState, useEffect } from 'react';
import { Button, Card } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { APIClient } from '../../helpers/api_helper';
import Breadcrumb from '../../Common/Breadcrumb';
import { useDispatch } from 'react-redux';
import { setInitialFilterConf } from '../../slices/filters/thunk'

const api = new APIClient();

const DownloadDBBackup = () => {
  document.title = "Varnostne kopije" + process.env.REACT_APP_PAGE_TITLE;
  const [downloading, setDownloading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: {},
      hidden: ['intent_type', 'intent_checkboxes_group', 'relateds_group', 'search', 'dt_range'],
      disabled: ['search']
    }))
  }, []);

  const loadLogs = () => {
    setLogsLoading(true);
    api.get('/api/backups/')
      .then(res => setLogs(res?.results ?? res ?? []))
      .catch(err => console.error('Backup logs fetch error:', err))
      .finally(() => setLogsLoading(false));
  };

  useEffect(() => { loadLogs(); }, []);

  const handleDownload = () => {
    setDownloading(true);
    api.get('/api/backups/download/')
      .then(res => {
        if (!res) return;
        const a = document.createElement('a');
        a.href = res.url;
        a.download = res.filename;
        a.click();
        loadLogs();
      })
      .catch(err => console.error('Backup download error:', err))
      .finally(() => setDownloading(false));
  };

  return (
    <>
      <Breadcrumb pageTitle="Varnostne kopije" />
      <Card loading={logsLoading}>
        <Button icon={<DownloadOutlined />} loading={downloading} onClick={handleDownload} style={{ marginBottom: 16 }}>
          Prenesi zadnjo kopijo
        </Button>
        <p>Kopija je šifrirana (.gpg). Za obnovo potrebujete geslo, ki ga hrani skrbnik sistema.</p>
        <hr />
        <h6>Zadnji prenosi</h6>
        {logs.map(log => (
          <div key={log.id}>
            {log.ago} — {log.username}
          </div>
        ))}
      </Card>
    </>
  );
};

export default DownloadDBBackup;
